<template>
  <div class="order" :style="bannerFlag ? 'margin-top: 56px;':''">
    <!-- 步骤标题 -->
    <div class="order-step w">
      <div class="order-step-right" v-if="currentNavSubList.length > 0">
        <button
          v-for="(sub, j) in currentNavSubList"
          :key="j"
          :class="['nav-sub-btn', { active: common.navSelect.navSubIndex === j }]"
          @click="onSubNavChange(j)">
          {{ sub.navLabel }}
        </button>
      </div>
    </div>

    <div class="order-list w">

      <div class="search-box">

        <div class="search-box-left">

          <div class="search-item">
            <el-input size="mini" placeholder="服务单号" prefix-icon="el-icon-search" v-model="queryParams.servOrderNo" clearable @keyup.enter.native="querySearch" @clear="querySearch">
            </el-input>
          </div>

          <div class="search-item">
            <el-input size="mini" placeholder="患者名称" prefix-icon="el-icon-search" v-model="queryParams.demPatient"
              clearable @keyup.enter.native="querySearch" @clear="querySearch">
            </el-input>
          </div>

          <div class="search-item">
            <el-cascader v-model="queryParams.servCataId" :options="common.category" :props="optionProps" clearable
              :show-all-levels="false" size="mini" placeholder="服务单类型" @change="changeServCataId">
            </el-cascader>
          </div>

          <div class="search-item">
            <el-select size="mini" v-model="queryParams.orderStatus" placeholder="服务单状态">
              <el-option class="option-item" v-for="item in common.dict.get('biz_order_status')" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div class="search-item">
            <el-switch v-model="queryParams.orderRushFlag" active-color="#00a5d5" inactive-color="#909399"
              active-value="1" inactive-value="0" active-text="加急" @change="changeOrderRushFlag">
            </el-switch>
          </div>
        </div>

        <div class="search-box-right">
          <y-button text="搜索" classStyle="main-btn" @btnClick="querySearch"></y-button>
          <y-button text="重置" classStyle="main-btn ml" @btnClick="resetSearch"></y-button>
        </div>

      </div>

      <div v-loading="loading" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0)">
        <div class="table-wrap">
          <el-table ref="multipleTable" :data="orderList" tooltip-effect="dark" style="width: 100%;font-size: 13px;"
            size="small" :stripe="true" border  v-if="orderList.length > 0">
            <el-table-column align="center" label="序号" width="58" show-overflow-tooltip>
              <template #default="scope">
                <span>{{(queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1}}</span>
              </template>
            </el-table-column>
            <el-table-column header-align="center" align="left" label="服务单号" width="210" show-overflow-tooltip>
              <template #default="scope">
                <div class="code-wrap">
                  {{scope.row.servOrderNo}}
                  <img src="/static/images/rush.png" v-if="scope.row.orderRushFlag === '1'">
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="demPatient" label="患者名称" width="80" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="服务单类型" align="center" width="150" show-overflow-tooltip>
              <template #default="scope">
                <serv-tag :code="scope.row.servCataId" />
              </template>
            </el-table-column>
            <el-table-column label="金额" width="90" align="center" show-overflow-tooltip>
              <template #default="scope">
                {{parseMoney(scope.row.orderAmount)}}
              </template>
            </el-table-column>
            <el-table-column prop="startTime" label="接单时间" width="143" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column :key="desKey+1" label="设计计时" width="120" align="center" show-overflow-tooltip>
              <template #default="scope">
                <span v-if="designTime(scope.row,'已锁定')" style="color: darkorange;">
                  已锁定
                </span>
                <span v-else-if="designTime(scope.row,'设计完成')" class="txtColor2">
                 设计完成
                </span>
                <span v-else-if="designTime(scope.row,'/')">
                  /
                </span>
              <span v-else-if="designTime(scope.row,'已超时')" class="txtColor3">
                 已超时
                </span>
                <span v-else>
                 {{timeFormat(scope.row.desTime)}}
                </span>
              </template>
            </el-table-column>
            <el-table-column :key="confirmKey" label="待确认计时" width="120" align="center" show-overflow-tooltip>
              <template #default="scope">
                <span v-if="confirmTime(scope.row,'已锁定')" style="color: darkorange;">
                  已锁定
                </span>
                <span v-else-if="confirmTime(scope.row,'确认完成')" class="txtColor2">
                  确认完成
                </span>
                <span v-else-if="confirmTime(scope.row,'/')">
                  /
                </span>
                <span v-else-if="confirmTime(scope.row,'已超时')" class="txtColor3">
                  已超时
                </span>
                <span v-else-if="scope.row.orderStatus != '20'">
                  {{timeFormat(scope.row.confirmTime)}}
                </span>
                <span v-else style="color: #ccc;">未激活</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center" width="147">
              <template #default="scope">
                <dict-tag style="display: inline;cursor: default;" dict="biz_order_status" :value="scope.row.orderStatus"/>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template #default="scope">
                <s-button text="详情" @btnClick="clickDetail(scope.row)"></s-button>
                <s-button text="删除" @btnClick="removeOrder(scope.row)" v-if="scope.row.orderStatus == '91'||scope.row.orderStatus == '92'"></s-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="no-data" v-if="noData">
            暂无数据
          </div>
        </div>
        <div class="pagination-wrap" v-if="orderList.length">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="queryParams.pageNum"
            :page-size="queryParams.pageSize" layout="total,prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
      <el-dialog :modal="false" :fullscreen="true" :modal-append-to-body="false" :visible.sync="dialogVisible"
        :show-close="false" class="dialog-wrap" :key="orderDetail.servOrderId">

        <div slot="title" class="dialog-wrap-header">

          <div class="dialog-header">
            {{orderDetail.servName}}<label> - </label>{{orderDetail.servOrderNo}}<label> - </label>{{orderDetail.demPatient}}
            <img src="/static/images/rush.png" v-if="orderDetail.orderRushFlag === '1'">
          </div>
          <div class="dialog-button">
            <!-- <y-button text="取消设计单" classStyle="main-btn" @btnClick="clickCancelOrder"></y-button> -->
            <y-button text="投诉" v-if="orderDetail.orderStatus == '20' || orderDetail.orderStatus == '30' || orderDetail.orderStatus == '40'"
               classStyle="main-btn" @btnClick="complaintFormVisible = true"></y-button>
            <y-button text="返回" classStyle="main-btn" @btnClick="clickCloseDetail"></y-button>
          </div>
        </div>
        <div class="dialog-wrap-content">
          <el-tabs v-model="activeName" type="card">
            <el-tab-pane name="info">
              <span slot="label" class="tabs-pane-title">
                <i class="el-icon-data-analysis"></i>
                <span>服务单详情</span>
              </span>
              <div class="tabs-pane-content">
                <detail-order v-if="!['4010110','3010130','4010120'].includes(orderDetail.servCataId)" :orderDetail="orderDetail"></detail-order>
                <orth-order v-if="['3010130'].includes(orderDetail.servCataId)" :orderDetail="orderDetail"></orth-order>
                <active-order v-if="['4010110','4010120'].includes(orderDetail.servCataId)" :orderDetail="orderDetail"></active-order>
              </div>
            </el-tab-pane>
            <el-tab-pane name="data">
              <span slot="label" class="tabs-pane-title">
                <i class="el-icon-film"></i>
                <span>数据下载</span>
              </span>
              <div class="tabs-pane-content">
                <detail-down :orderDetail="orderDetail"></detail-down>
              </div>
            </el-tab-pane>
            <el-tab-pane name="design">
              <span slot="label" class="tabs-pane-title">
                <i class="el-icon-finished"></i>
                <span>设计信息</span>
              </span>
              <div class="tabs-pane-content">
                <detail-upload :orderDetail="orderDetail" :report="orderDetail.designReport" :guide="orderDetail.designGuide" @update:orderDetail="handleOrderDetailUpdate"></detail-upload>
              </div>
            </el-tab-pane>
           <el-tab-pane name="activity">
              <span slot="label" class="tabs-pane-title">
                <i class="el-icon-timer"></i>
                <span>进度详情</span>
              </span>
              <div class="tabs-pane-content">
                <detail-activity :orderDetail="orderDetail"></detail-activity>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-dialog>
    </div>
   <el-dialog :visible.sync="complaintFormVisible" width="30%" margin-top="20vh" append-to-body>
      <div slot="title" class="pay-wrap-header">
        <span>申请投诉发单方</span>
      </div>
      <el-form label-position="left" :model="ruleForm" ref="ruleForm">
        <el-form-item prop="content" label="投诉理由:" label-width="120px"
          :rules="{ required: true, message: '投诉理由不能为空', trigger: 'blur'}"
        >
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}" v-model="ruleForm.content" placeholder="请详细说明投诉的原因"></el-input>
        </el-form-item>
        <el-form-item label="图片说明:" label-width="120px">
          <el-upload list-type="picture-card" action :http-request="uploadFile"
            :data="{objectType:'18',objectTag: orderDetail.servOrderId}" :auto-upload="true" :limit="3" multiple
            :show-file-list="true" :before-upload="beforeUpload">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="complaintFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm','3')">提 交</el-button>
      </div>
    </el-dialog>
    <Customer class="customerSer" :friendUid="orderDetail.demUserId"></Customer>
  </div>
</template>
<script>
  import YTooth from '/components/YTooth'
  import YShelf from '/components/YShelf'
  import YButton from '/components/YButton'
  import SButton from '/components/SButton'
  import DictTag from '/components/DictTag'
  import ServTag from '/components/ServTag'
  import BaseTag from '/components/BaseTag'
  import DetailOrder from './detailOrder';
  import DetailDown from './detailDown';
  import DetailDesign from './detailDesign';
  import DetailUpload from './detailUpload';
  import DetailActivity from './detailActivity';
  import Customer from './components/customerSer';
  import ActiveOrder from './activeModification/activeDetail';
  import OrthOrder from './orthodonticsOrder/orthodonticsOrderDetail';

  import {
    getStore
  } from '/utils/storage'
  import {
    mapState
  } from 'vuex'
import Vue from 'vue'
import {uploadByPieces} from "../../../common/upload.js";
import navDesList from "/assets/config/navDesList.js";
  let that;
  export default {
    data() {
      return {
        bannerFlag: false,
        complaintFormVisible: false,
        loading: true,
        noData: false,
        orderList: [],
        selectIds: [],
        total: 0,
        queryParams: {
          pageNum: 1,
          pageSize: 15,
          servOrderNo: '',
          demPatient:'',
          servCataId: [],
          orderStatus: '',
          orderRushFlag: ''
        },
        orderDetail: {},
        dialogVisible: false,
        confirmVisible: false,
        activeName: 'info',
        optionProps: {
          value: 'servId',
          label: 'servName',
          children: 'children',
          expandTrigger: 'hover'
        },
        ruleForm: {
          content: ''
        },
        reasonImages:[],
        confirmKey:0,
        desKey:0,
        activityList:[],
        timeDown:'',//倒计时定时任务
        submitLock:false,
      }
    },
    computed: {
      ...mapState(['common', 'user']),
      currentNavSubList() {
        var navList = navDesList;
        var idx = this.common.navSelect.navIndex;
        if (idx >= 0 && navList[idx] && navList[idx].navSubList) {
          return navList[idx].navSubList;
        }
        return [];
      },
      designTime(){
        return function(row,msg){
          let flag = false;
          let list = [];
          let statusFlag = '';
          let id = row.servCataId;
          let status = row.orderStatus;
          let str = this.timeFormat(row.desTime) == '已超时';
          switch(msg){
            case '已锁定':
              statusFlag = ['50','60'].includes(status);
              if(statusFlag){
                flag = true;
              }
              break;
            case '设计完成':
              list = id == '3010130'?['30','31','40','50','99']:['30','40','50','99']
              statusFlag = list.includes(status);
              if(statusFlag&&str){
                flag = true;
              }
              break;
            case '/':
              list = id=='3010130'?['20','31']:['20']
              statusFlag = !list.includes(status);
              if(statusFlag){
                flag = true;
              }
              break;
            case '已超时':
              statusFlag = ['93'].includes(status);
              if(statusFlag){
                flag = true;
              }
              break;
          }
          return flag;
        }
      },
      // 待确认计时
      confirmTime(){
        return function(row,msg){
          let list = [];
          let flag = false;
          let statusFlag = '';
          let id = row.servCataId;
          let status = row.orderStatus;
          let str = this.timeFormat(row.confirmTime) == '已超时';
          switch(msg){
            case '已锁定':
            statusFlag = ['50','60'].includes(status);
            if(statusFlag&&str){
              flag = true;
            }
              break;
            case '确认完成':
            statusFlag = ['99'].includes(status);
            if(statusFlag&&str){
              flag = true;
            }
              break;
            case '/':
            list = id == '3010130'?['30','31','40']:['30','40'];
            statusFlag = !list.includes(status);
            if(statusFlag){
              flag = true;
            }
              break;
            case '已超时':
            statusFlag = ['20','93'].includes(status);
            if(str){
              flag = true;
            }
              break;
          }
          return flag;
        }
      },
      // 处理服务器时间倒计时
      // handleNowTime(){
      //   return function(time){
      //     this.timeDown = setInterval(() => {
      //       if(time>0){
      //         time -= 1000;
      //         console.log('time',time)
      //       }else {
      //         clearInterval(this.timeDown);
      //       }
      //     }, 1000)
      //     return time;
      //   }
      // }
    },
    methods: {
      onSubNavChange(val) {
        const sub = this.currentNavSubList[val];
        if (!sub) return;
        if (sub.linkType === 1) {
          this.$yxz.to('/' + sub.linkUrl);
        } else if (sub.linkType === 2) {
          var url = '//' + window.location.host + '/#/' + sub.linkUrl;
          if (sub.query) {
            var qs = [];
            for (var k in sub.query) { qs.push(k + '=' + sub.query[k]); }
            if (qs.length > 0) url += '?' + qs.join('&');
          }
          window.open(url);
        } else if (sub.linkType === 9) {
          this.$router.push({ path: "/" + sub.linkUrl, query: sub.query });
        } else {
          window.open(sub.linkUrl);
        }
      },
      loadDataList() {
        this.loading = true;
        this.$api.get({
          url: '/biz/orderServ/des/list',
          data: this.queryParams
        }).then(res => {
          this.noData = res.total > 0 ? false : true;
          this.total = res.total
          this.loading = false
          // 处理订单列表排序，客服取消订单滞后
          let targetStatus = '92'
          this.orderList = res.rows
          this.orderList.sort((a,b)=>{
            const aIsTarget = a.orderStatus === targetStatus;
            const bIsTarget = b.orderStatus === targetStatus;
            if (aIsTarget && bIsTarget || !aIsTarget && !bIsTarget) {
              return a.orderStatus - b.orderStatus;
            }
            if (aIsTarget) {
              return 1;
            }
            if (bIsTarget) {
              return -1;
            }
            return 0;
          })
          this.orderList.forEach((row) => {
              this.daojishi(row,res.nowTime);
          });
          this.orderList.sort((a,b)=>a.orderStatus - b.orderStatus)
        })
      },
      daojishi(row,times) {
        // 服务器当前时间定时任务
        this.timeDown = setInterval(() => {
          if (times > 0) {
            times += 1000;
          } else {
            clearInterval(this.timeDown);
          }
        }, 1000)
        if(row.orderStatus=="20") {
          row.desCountDown = setInterval(() => {
              let residue = new Date(row.expectTime).getTime() - times;
              if (residue > 0) {
                  row.desTime = residue;
                  this.desKey=Math.random()
              } else {
                  clearInterval(row.desCountDown);
              }
          }, 1000);
          row.desTime = new Date(row.expectTime).getTime() - times;
        }else if(row.orderStatus=="30" || row.orderStatus=="31" || row.orderStatus=="40" || row.orderStatus=="50") {
          if(row.desCountDown) {
            clearInterval(row.desCountDown);
          }
          row.confirmCountDown = setInterval(() => {
              let residue = new Date(row.expectTime).getTime() - times;
              if (residue > 0) {
                  row.confirmTime = residue;
                  this.confirmKey=Math.random()
              } else {
                clearInterval(row.confirmCountDown);
              }
          }, 1000);
          row.confirmTime = new Date(row.expectTime).getTime() - times;
        }else {
          if(row.desCountDown) {
            clearInterval(row.desCountDown);
          }
          if(row.confirmCountDown) {
            clearInterval(row.confirmCountDown);
          }
        }
      },
      timeFormat(times) {
        if (times > 0) {
          let days = this.addZero(
              Math.floor(times / 1000 / 60 / 60 / 24)
          );
          let hours = this.addZero(
              Math.floor((times / 1000 / 60 / 60) % 24)
          );
          let minutes = this.addZero(
              Math.floor((times / 1000 / 60) % 60)
          );
          let seconds = this.addZero(Math.floor((times / 1000) % 60)); //秒
          if(days=='00'&& hours!='00') {
            return `${hours}时${minutes}分${seconds}秒`;
          }else if (days=='00' && hours=='00'){
            return `${minutes}分${seconds}秒`;
          }else {
            return `${days}天${hours}时${minutes}分${seconds}秒`;
          }
        } else {
          return "已超时";
        }
      },
      // 个位补零
      addZero(d) {
        return parseInt(d) < 10 ? "0" + d : d;
      },
      handleSelectionChange(selection) {
        this.selectIds = selection.map(item => item.servOrderId);
      },
      handleCurrentChange(val) {
        this.queryParams.pageNum = val
        this.loadDataList()
      },
      changeServCataId() {
        this.queryParams.servCataId = this.queryParams.servCataId[1];
      },
      changeOrderRushFlag() {
        if (this.queryParams.orderRushFlag === '0') {
          this.queryParams.orderRushFlag = '';
        }
        this.loadDataList()
      },
      querySearch() {
        this.loadDataList();
      },
      resetSearch() {
        this.total = 0;
        this.queryParams.pageNum = 1;
        this.queryParams.pageSize = 15;
        this.queryParams.servOrderNo = '';
        this.queryParams.demPatient = '';
        this.queryParams.servCataId = [];
        this.queryParams.orderStatus = '';
        this.queryParams.orderRushFlag = '';
        this.loadDataList();
      },
      clickDetail(row) {
        this.loading = true
        sessionStorage.setItem("orderId",row.servOrderId)
        this.$api.get({
          url: '/biz/orderServ/detail/' + row.servOrderId
        }).then(res => {
          this.loading = false
          this.dialogVisible = true;
          this.activeName = 'info';
          let detailData = {};
          let single = res.data.posSingle;
          let bridge = res.data.posBridge;
          for (var key in res.data) {
            if (key === "posSingle"&&single!=''&&single!=null) {
              detailData.posSingleList = single.split(',');
            } else if (key === "posBridge"&&bridge!=''&&bridge!=null) {
              detailData.posBridgeList = bridge.split(',');
            } else {
              detailData[key] = res.data[key];
            }
          }
          this.orderDetail = detailData;
          this.strTo()
        })
      },
      /**
       * 设计师留言回调更新服务单数据
       * @param {Object} newOrderDetail 订单详情
       */
      handleOrderDetailUpdate(newOrderDetail) {
        let detailData = {};
        for (var key in newOrderDetail) {
          if (key === "posSingle") {
            detailData.posSingleList = newOrderDetail.posSingle.split(',');
          } else if (key === "posBridge") {
            detailData.posBridgeList = newOrderDetail.posBridge.split(',');
          } else {
            detailData[key] = newOrderDetail[key];
          }
        }
        this.orderDetail = detailData;
        this.strTo()
      },
      //删除订单
      removeOrder(row){
        this.$confirm('确定删除服务单【' + row.servOrderNo + '】?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true
        }).then(() => {
          this.loading = true
          this.$api.get({
            url: '/biz/orderServ/dem/delete/' + row.servOrderId
          }).then(res => {
            this.loading = false
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.loadDataList();
          })
        }).catch(() => {});
      },
      strTo(){
        this.orderDetail.servName = this.common.serv.get(this.orderDetail.servCataId).servName;
        if(this.orderDetail.withServCataId){
          var arr =  this.orderDetail.withServCataId.split(',')
          arr.forEach((k,i)=>{
            if(this.orderDetail.servCataId!='1010410'&&this.orderDetail.servCataId!=arr[i]){
              this.orderDetail.servName += '+'+this.common.serv.get(arr[i]).servName;
            }
          })
        }
      },
      clickCloseDetail() {
        this.dialogVisible = false;
        this.activeName = 'info';
        this.orderDetail = {};
        sessionStorage.removeItem('orderId')
        this.loadDataList();
      },
      clickCancelOrder() {

        this.$confirm('确定取消设计单【' + this.orderDetail.servOrderNo + '】?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true
        }).then(() => {

          this.loading = true
          this.$api.get({
            url: '/biz/orderServ/des/cancel/' + this.orderDetail.servOrderId
          }).then(res => {

            this.loading = false
            this.$message({
              type: 'success',
              message: '取消成功!'
            });

            this.clickCloseDetail()
            this.loadDataList();

          })

        }).catch(() => {});
      },
      // 控制顶部
      navFixed() {
        if (this.$route.path === '/order/mall') {
          var st = document.documentElement.scrollTop || document.body.scrollTop
          st >= 60 ? this.bannerFlag = true : this.bannerFlag = false
        } else {
          return
        }
      },
      async uploadFile({response,file,data}) {
        var loading = this.$loading({
          text: '等待上传完成，已上传 0%'
        });
        var that = this
        uploadByPieces({
          file: file, // 文件
          data: data,
          pieceSize: 3, // 分片大小
          concurrent: 3,
          process: res => {
            loading.setText('等待上传完成，已上传'+res+'%')
            console.log('分片上传 -> process', res)
            if (res == 100) {
              loading.close();
            }
          },
          success: res => {
            if (data.objectType == '18') { //设计文件
              this.reasonImages.push(res.data.url)
            }
            loading.close();
            // console.log('分片上传 -> success', res)
          },
          error: e => {
            loading.close();
            // console.log('分片上传 -> error', e)
          }
        })
      },
      submitForm(formName,type) {
        if(this.submitLock)return;
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitLock = true;
            let formData = new FormData();
            for (var key in that.ruleForm) {
              formData.append(key, that.ruleForm[key]);
            }
            this.addForm(formData,type);
            this.dialogFormVisible = false
            setTimeout(()=>{
              this.submitLock = false;
            },3000);
          } else {
            this.$yxz.msg('请填写投诉理由！')
            return false;
          }
        });
      },
      //添加
      addForm(formData,type) {
        var data = {
          servOrderId: this.orderDetail.servOrderId,
          reasonContent: formData.get('content'),
          reasonImages: this.reasonImages.join(','),
          activityType:type
        }

        this.$api.post({
          url: '/biz/orderServ/dem/change',
          data: data
        }).then(res => {
          if (res.code == 200) {
            this.$yxz.msg('提交成功', 'success')
            this.ruleForm.content = ''
            this.reasonImages = []
            this.complaintFormVisible = false
          } else {
            this.$yxz.msg(res.msg);
          }
        })
      },
      // 更改设计/投诉上传限制
      beforeUpload(file){
        console.log('file',file)
        if(!['image/jpeg','image/png'].includes(file.type)){
          this.$message({
            type: 'error',
            message: '请上传jpg或png格式的图片'
          });
          return false;
        }
      }
    },
    created() {
      this.$store.commit('common/recordNav', {
        navIndex: 1,
        navSubIndex: 1
      })
      this.loadDataList();
      let id = sessionStorage.getItem("orderId")
      if(id){
        this.loading = true
        this.$api.get({
          url: '/biz/orderServ/detail/' + id
        }).then(res => {
          console.log('res',res)
          this.loading = false
          this.dialogVisible = true;
          this.activeName = 'info';
          let detailData = {};

          let single = res.data.posSingle;
          let bridge = res.data.posBridge;
          for (var key in res.data) {
            if (key === "posSingle"&&single!=''&&single!=null) {
              detailData.posSingleList = single.split(',');
            } else if (key === "posBridge"&&bridge!=''&&bridge!=null) {
              detailData.posBridgeList = bridge.split(',');
            } else {
              detailData[key] = res.data[key];
            }
          }
          this.orderDetail = detailData;
          this.strTo()
        })
      }
    },
    mounted() {
      this.navFixed()
      window.addEventListener('scroll', this.navFixed)
      window.addEventListener('resize', this.navFixed)
      document.title = "医小智 - 我的设计单"
    },
    beforeDestroy() {
      clearInterval(this.timeDown);
    },
    components: {
      YTooth,
      YShelf,
      YButton,
      SButton,
      BaseTag,
      DictTag,
      ServTag,
      DetailOrder,
      DetailDown,
      DetailDesign,
      DetailUpload,
      DetailActivity,
      Customer,
      ActiveOrder,
      OrthOrder
    }
  }
</script>
<style lang="scss" scoped>
  @import "../../assets/style/mixin";

  .order {
    display: flex;
    flex-direction: column;
    perspective: 3000px;
    position: relative;
    z-index: 19;
    margin: 0 auto;
    flex-grow: 1;
  }

  .order-step {
    position: relative;
    overflow: hidden;
    background: transparent;
    min-height: 56px;
    line-height: 56px;
    font-size: 14px;
    color: #999;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    z-index: 10;
    padding: 0 20px;
    margin: 8px auto;
    flex-shrink: 0;

    .order-step-right {
      flex-shrink: 0;
      margin-right: 20px;

      .nav-sub-btn {
        margin: 0 8px;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        padding: 6px 16px;
        font-size: 13px;
        background: #fff;
        color: #606266;
        cursor: pointer;
        transition: all 0.25s ease;
        outline: none;

        &.active {
          background: #1890ff;
          border-color: #1890ff;
          color: #fff;
          box-shadow: 0 2px 6px rgba(24, 144, 255, 0.3);
        }

        &:not(.active):hover {
          color: #1890ff;
          border-color: rgba(24, 144, 255, 0.4);
        }
      }
    }
  }

.search-box {
    position: relative;
    overflow: hidden;
    position: relative;
    margin: 10px;
    padding: 10px;
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    color: #626262;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    z-index: 10;

    .floor-btn {
      display: inline-block;
      height: 32px;
      line-height: 32px;
      border: 1px solid #e1e1e1;
      padding: 0 15px;
      color: #666;
      font-size: 14px;
      border-radius: 5px;
      background: -webkit-linear-gradient(#fbfbfb, #ececec);
      background: linear-gradient(#fbfbfb, #ececec);
      background-image: -webkit-gradient(linear, left top, left bottom, from(#fbfbfb), to(#ececec));
      background-image: linear-gradient(180deg, #fbfbfb, #ececec);
    }

    .search-box-left {
      display: flex;
      flex-direction: row;
    }

    .search-item {
      margin-right: 10px;

      &.mt {
        margin-top: 1px;
      }
    }

    .search-box-right {
      display: flex;
      flex-direction: row;
    }

  }

  .order-list {
    border-radius: 12px;
    position: relative;
    z-index: 20;
    min-height: calc(100vh - 70px - 73px - 56px - 35px);
    background: #f7f7f7;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;

    .search-box {
      padding: 10px;
      flex-shrink: 0;
    }

    > div[v-loading] {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }
  }

  .table-wrap {
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-height: 0;
  }

  .code-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      width: 20px;
      height: 20px;
    }
  }

  .dialog-wrap {
    width: 1220px;
    margin: 0 auto;
  }

  .dialog-wrap-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 45px;
  }

  .dialog-header {
    display: flex;
    align-items: center;
    font-size: 18px;
    line-height: 32px;
    font-weight: 500;

    label {
      margin: 0 10px;
    }

    img {
      width: 26px;
      height: 26px;
      margin-left: 10px;
      margin-top: -5px;
    }
  }


  .dialog-wrap-content {
    margin: 0 10px;
    margin-top: -30px;
    background: #F7F7F7;
  }

  .tabs-pane-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: normal;

    span {
      margin-left: 5px;
    }

    i {
      font-size: 16px;
    }
  }

  .el-tabs__item.is-active {
    color: #00a5d5;
  }

  .el-tabs__active-bar {
    background-color: #00a5d5;
  }

  .el-tabs__item:hover {
    color: #00a5d5;
    cursor: pointer;
  }

  .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #00a5d5;
  }

  .tabs-pane-content {
    height: calc(100vh - 280px);
    border-bottom: 1px solid #E4E7ED;
    padding: 5px 20px 20px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .el-dialog {
    border-radius: 8px;
    background: #f7f7f7;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  }

  .el-table__body-wrapper::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 0px;
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 2px;
    height: 50px;
    background: #eee;
  }

  .el-table__body-wrapper::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    background: rgba(0, 0, 0, 0.4);
  }

  .el-switch__label.is-active {
    color: #00a5d5;
  }

  .el-switch__label {
    -webkit-transition: .2s;
    transition: .2s;
    font-size: 13px;
    vertical-align: middle;
    color: #909399;
  }

  .el-switch__label * {
    line-height: 1;
    font-size: 13px;
    display: inline-block;
  }

  .el-button--primary {
    color: #FFF;
    background-color: #00a5d5;
    border-color: #00a5d5;
  }

  .el-button--primary:hover {
    color: #FFF;
    background-color: #6c8cd4;
    background-image: -webkit-linear-gradient(top, #6c8cd4, #00a5d5);
    background-image: linear-gradient(180deg, #6c8cd4, #00a5d5);
  }

  .pagination-wrap {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 5px 15px;
  }

  .el-dialog__header {
    padding: 10px 20px 10px;
  }

  .el-pager li.active {
    color: #00a5d5;
    cursor: default;
  }

  .el-pager li:hover {
    color: #00a5d5;
  }

  .el-icon-arrow-left:hover {
    color: #00a5d5;
  }

  .el-icon-arrow-right:hover {
    color: #00a5d5;
  }

  .el-pagination span:not([class*=suffix]) {
    display: inline-block;
    font-size: 12px;
    min-width: 35.5px;
    height: 28px;
    line-height: 28px;
    vertical-align: top;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #00a5d5;
    border-color: #00a5d5;
  }

  .no-data {
    min-height: 527px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .txtColor1{
	  color: #ccc;
  }
  .txtColor2{
  	  color: #00B050;;
  }
  .txtColor3{
  	  color: red;
  }
  .item:hover {
    text-decoration: underline;
  }
  .item {
    margin-top: 5px;
  }
</style>
<style>
.dialog-wrap {
  .el-dialog{
    overflow-y: hidden;
    background-color: #F7F7F7;
  }
}
</style>



// WEBPACK FOOTER //
// orderDes.vue?076c00b1